import Lisa2 from '../../pages/lisa2/Lisa2'

import PrefixEnum from '../prefixes'

export default Object.freeze([{ path: PrefixEnum.LISA2, component: Lisa2 }])
